import React from 'react';
import { Routes } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import PromotionConfigurePage from './PromotionConfigurePage';
import PromotionCreatePage from './PromotionCreatePage';
import PromotionUpdatePage from './PromotionUpdatePage';

const Promotion: React.FC = () => (
  <Routes>
    <Route
      path='create'
      element={
        <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
          <PromotionCreatePage />
        </ProtectedRoute>
      }
    />
    <Route path=':promotionId/configure/*' element={<PromotionConfigurePage />} />
    <Route path=':promotionId/update/*' element={<PromotionUpdatePage />} />
  </Routes>
);

export default Promotion;
